export interface CommercialNetworkServices {
  tire_care_member: boolean,
  mcsn: boolean,
  mechanical_care_dealer: boolean,
}

export interface CommercialTireServices {
  wheel_refurbishing: {
    powder_coating: boolean,
    polishing: boolean,
  },
  tire_mounting: {
    mobile: {
      light_medium_duty: boolean,
      heavy_duty: boolean,
    },
    in_bay: {
      light_medium_duty: boolean,
      heavy_duty: boolean,
    }
  },
  tire_rotations: {
    mobile: {
      light_medium_duty: boolean,
      heavy_duty: boolean,
    },
    in_bay: {
      light_medium_duty: boolean,
      heavy_duty: boolean,
    }
  },
  vehicle_alignment: {
    mobile: {
      light_medium_duty: boolean,
      heavy_duty: boolean,
    },
    in_bay: {
      light_medium_duty: boolean,
      heavy_duty: boolean,
    }
  },
  tpms_reset_and_replacement: {
    mobile: {
      light_medium_duty: boolean,
      heavy_duty: boolean,
    },
    in_bay: {
      light_medium_duty: boolean,
      heavy_duty: boolean,
    }
  },
  mounted_wheel_program: {
    mobile: {
      light_medium_duty: boolean,
      heavy_duty: boolean,
    },
    in_bay: {
      light_medium_duty: boolean,
      heavy_duty: boolean,
    }
  },
  nail_hole_repair: {
    mobile: {
      light_medium_duty: boolean,
      heavy_duty: boolean,
    },
    in_bay: {
      light_medium_duty: boolean,
      heavy_duty: boolean,
    }
  },
  tire_balancing: {
    mobile: {
      light_medium_duty: boolean,
      heavy_duty: boolean,
    },
    in_bay: {
      light_medium_duty: boolean,
      heavy_duty: boolean,
    }
  },
  tire_inspections: {
    mobile: {
      light_medium_duty: boolean,
      heavy_duty: boolean,
    },
    in_bay: {
      light_medium_duty: boolean,
      heavy_duty: boolean,
    }
  },
  tire_repairs: {
    in_bay: { heavy_duty: boolean },
  },
  tia_certified_technicians: {
    certificate_or_equivalent_300: {
      ats: boolean,
    },
    training_200: {
      ats: boolean,
      cts: boolean,
    }
  }
}

export interface CommercialMechanicalServices {
  number_of_dedicated_mobile_mechanical_units: number,
  towing: {
    less_than_10_lbs: boolean,
    between_10_and_26_lbs: boolean,
    greater_than_26_lbs: boolean,
  },
  basic_mechanical: BasicMechanical,
  ase_certified_mechanics?: {
    l3_light_duty_hybrid_electric_vehicle: boolean,
    state_certifications: any[],
    a2_automatic_transmission_transaxle: boolean,
    a7_heating_and_air_conditioning: boolean,
    a8_engine_performance: boolean,
    a5_brakes: boolean,
    a9_light_vehicles_diesel_engines: boolean,
    a3_manual_drive_train_and_axles: boolean,
    a6_electrical_electronic_systems: boolean,
    g1_auto_maintenance_and_light_repair: boolean,
    a1_engine_repair: boolean,
    a4_suspension_and_steering: boolean,
  },
  light_mechanical: {
    air_conditioning_repair: {
      mobile: {
        light_medium_duty: boolean,
        heavy_duty: boolean,
      },
      michelin_verified: boolean,
      in_bay: {
        light_medium_duty: boolean,
        heavy_duty: boolean,
      }
    },
    seals_and_bearing_replacement: {
      mobile: {
        light_medium_duty: boolean,
        heavy_duty: boolean,
      },
      michelin_verified: boolean,
      in_bay: {
        light_medium_duty: boolean,
        heavy_duty: boolean,
      }
    },
    alternator_replacement: {
      mobile: {
        light_medium_duty: boolean,
        heavy_duty: boolean,
      },
      michelin_verified: boolean,
      in_bay: {
        light_medium_duty: boolean,
        heavy_duty: boolean,
      }
    },
    windshield_wipers: {
      mobile: {
        light_medium_duty: boolean,
        heavy_duty: boolean,
      },
      michelin_verified: boolean,
      in_bay: {
        light_medium_duty: boolean,
        heavy_duty: boolean,
      }
    },
    electric_vehicle_charging: {
      mobile: {
        light_medium_duty: boolean,
        heavy_duty: boolean,
      },
      michelin_verified: boolean,
      in_bay: {
        light_medium_duty: boolean,
        heavy_duty: boolean,
      }
    },
    vehicle_disinfecting: {
      mobile: {
        light_medium_duty: boolean,
        heavy_duty: boolean,
      },
      michelin_verified: boolean,
      in_bay: {
        light_medium_duty: boolean,
        heavy_duty: boolean,
      }
    },
    air_filter_replacement: {
      mobile: {
        light_medium_duty: boolean,
        heavy_duty: boolean,
      },
      michelin_verified: boolean,
      in_bay: {
        light_medium_duty: boolean,
        heavy_duty: boolean,
      }
    },
    basic_brake_service: {
      mobile: {
        light_medium_duty: boolean,
        heavy_duty: boolean,
      },
      michelin_verified: boolean,
      in_bay: {
        light_medium_duty: boolean,
        heavy_duty: boolean,
      }
    },
    dot_annual_inspection: {
      mobile: {
        light_medium_duty: boolean,
        heavy_duty: boolean,
      },
      michelin_verified: boolean,
      in_bay: {
        light_medium_duty: boolean,
        heavy_duty: boolean,
      }
    },
    vehicle_washes: {
      mobile: {
        light_medium_duty: boolean,
        heavy_duty: boolean,
      },
      michelin_verified: boolean,
      in_bay: {
        light_medium_duty: boolean,
        heavy_duty: boolean,
      }
    },
    battery_replacement: {
      mobile: {
        light_medium_duty: boolean,
        heavy_duty: boolean,
      },
      michelin_verified: boolean,
      in_bay: {
        light_medium_duty: boolean,
        heavy_duty: boolean,
      }
    },
    cabin_filter_replacement: {
      mobile: {
        light_medium_duty: boolean,
        heavy_duty: boolean,
      },
      michelin_verified: boolean,
      in_bay: {
        light_medium_duty: boolean,
        heavy_duty: boolean,
      }
    },
    light_replacement: {
      mobile: {
        light_medium_duty: boolean,
        heavy_duty: boolean,
      },
      michelin_verified: boolean,
      in_bay: {
        light_medium_duty: boolean,
        heavy_duty: boolean,
      }
    },
    belts_and_hoses: {
      mobile: {
        light_medium_duty: boolean,
        heavy_duty: boolean,
      },
      michelin_verified: boolean,
      in_bay: {
        light_medium_duty: boolean,
        heavy_duty: boolean,
      }
    },
    lightbulb_replacement: {
      mobile: {
        light_medium_duty: boolean,
        heavy_duty: boolean,
      },
      michelin_verified: boolean,
      in_bay: {
        light_medium_duty: boolean,
        heavy_duty: boolean,
      }
    },
    basic_electrical: {
      mobile: {
        light_medium_duty: boolean,
        heavy_duty: boolean,
      },
      michelin_verified: boolean,
      in_bay: {
        light_medium_duty: boolean,
        heavy_duty: boolean,
      }
    },
    full_unit_inspection: {
      mobile: {
        light_medium_duty: boolean,
        heavy_duty: boolean,
      },
      michelin_verified: boolean,
      in_bay: {
        light_medium_duty: boolean,
        heavy_duty: boolean,
      }
    },
    state_inspection: {
      mobile: {
        light_medium_duty: boolean,
        heavy_duty: boolean,
      },
      michelin_verified: boolean,
      in_bay: {
        light_medium_duty: boolean,
        heavy_duty: boolean,
      }
    },
    wheel_end_replacement: {
      mobile: {
        light_medium_duty: boolean,
        heavy_duty: boolean,
      },
      michelin_verified: boolean,
      in_bay: {
        light_medium_duty: boolean,
        heavy_duty: boolean,
      }
    },
    alignment: {
      mobile: {
        light_medium_duty: boolean,
        heavy_duty: boolean,
      },
      michelin_verified: boolean,
      in_bay: {
        light_medium_duty: boolean,
        heavy_duty: boolean,
      }
    }
  },
  wet_mechanical: {
    other_services: {
      transfer_case_fluid_exchange: {
        mobile: {
          light_medium_duty: boolean,
          heavy_duty: boolean,
        },
        michelin_verified: boolean,
        in_bay: {
          light_medium_duty: boolean,
          heavy_duty: boolean,
        }
      },
      power_steering_fluid_exchange: {
        mobile: {
          light_medium_duty: boolean,
          heavy_duty: boolean,
        },
        michelin_verified: boolean,
        in_bay: {
          light_medium_duty: boolean,
          heavy_duty: boolean,
        }
      },
      oil_change: {
        mobile: {
          light_medium_duty: boolean,
          heavy_duty: boolean,
        },
        michelin_verified: boolean,
        in_bay: {
          light_medium_duty: boolean,
          heavy_duty: boolean,
        }
      },
      coolant_exchange: {
        mobile: {
          light_medium_duty: boolean,
          heavy_duty: boolean,
        },
        michelin_verified: boolean,
        in_bay: {
          light_medium_duty: boolean,
          heavy_duty: boolean,
        }
      },
      fuel_system_repair: {
        mobile: {
          light_medium_duty: boolean,
          heavy_duty: boolean,
        },
        michelin_verified: boolean,
        in_bay: {
          light_medium_duty: boolean,
          heavy_duty: boolean,
        }
      },
      transmission_fluid_exchange: {
        mobile: {
          light_medium_duty: boolean,
          heavy_duty: boolean,
        },
        michelin_verified: boolean,
        in_bay: {
          light_medium_duty: boolean,
          heavy_duty: boolean,
        }
      },
      differential_fluid_exchange: {
        mobile: {
          light_medium_duty: boolean,
          heavy_duty: boolean,
        },
        michelin_verified: boolean,
        in_bay: {
          light_medium_duty: boolean,
          heavy_duty: boolean,
        }
      },
      brake_fluid_exchange: {
        mobile: {
          light_medium_duty: boolean,
          heavy_duty: boolean,
        },
        michelin_verified: boolean,
        in_bay: {
          light_medium_duty: boolean,
          heavy_duty: boolean,
        }
      }
    },
    refills_top_offs: {
      oil: {
        mobile: {
          light_medium_duty: boolean,
          heavy_duty: boolean,
        },
        michelin_verified: boolean,
        in_bay: {
          light_medium_duty: boolean,
          heavy_duty: boolean,
        }
      },
      transmission_fluid: {
        mobile: {
          light_medium_duty: boolean,
          heavy_duty: boolean,
        },
        michelin_verified: boolean,
        in_bay: {
          light_medium_duty: boolean,
          heavy_duty: boolean,
        }
      },
      fuel_refill_gas: {
        mobile: {
          light_medium_duty: boolean,
          heavy_duty: boolean,
        },
        michelin_verified: boolean,
        in_bay: {
          light_medium_duty: boolean,
          heavy_duty: boolean,
        }
      },
      brake_fluids: {
        mobile: {
          light_medium_duty: boolean,
          heavy_duty: boolean,
        },
        michelin_verified: boolean,
        in_bay: {
          light_medium_duty: boolean,
          heavy_duty: boolean,
        }
      },
      windshield_fluid: {
        mobile: {
          light_medium_duty: boolean,
          heavy_duty: boolean,
        },
        michelin_verified: boolean,
        in_bay: {
          light_medium_duty: boolean,
          heavy_duty: boolean,
        }
      },
      diesel_emission_fluid: {
        mobile: {
          light_medium_duty: boolean,
          heavy_duty: boolean,
        },
        michelin_verified: boolean,
        in_bay: {
          light_medium_duty: boolean,
          heavy_duty: boolean,
        }
      },
      power_steering_fluid: {
        mobile: {
          light_medium_duty: boolean,
          heavy_duty: boolean,
        },
        michelin_verified: boolean,
        in_bay: {
          light_medium_duty: boolean,
          heavy_duty: boolean,
        }
      },
      coolant: {
        mobile: {
          light_medium_duty: boolean,
          heavy_duty: boolean,
        },
        michelin_verified: boolean,
        in_bay: {
          light_medium_duty: boolean,
          heavy_duty: boolean,
        }
      },
      fuel_refill_diesel: {
        mobile: {
          light_medium_duty: boolean,
          heavy_duty: boolean,
        },
        michelin_verified: boolean,
        in_bay: {
          light_medium_duty: boolean,
          heavy_duty: boolean,
        }
      }
    },
    flushes: {
      fuel_system_cleaning: {
        mobile: {
          light_medium_duty: boolean,
          heavy_duty: boolean,
        },
        michelin_verified: boolean,
        in_bay: {
          light_medium_duty: boolean,
          heavy_duty: boolean,
        }
      },
      oil: {
        mobile: {
          light_medium_duty: boolean,
          heavy_duty: boolean,
        },
        michelin_verified: boolean,
        in_bay: {
          light_medium_duty: boolean,
          heavy_duty: boolean,
        }
      },
      transmission: {
        mobile: {
          light_medium_duty: boolean,
          heavy_duty: boolean,
        },
        michelin_verified: boolean,
        in_bay: {
          light_medium_duty: boolean,
          heavy_duty: boolean,
        }
      },
      brake_fluid: {
        mobile: {
          light_medium_duty: boolean,
          heavy_duty: boolean,
        },
        michelin_verified: boolean,
        in_bay: {
          light_medium_duty: boolean,
          heavy_duty: boolean,
        }
      },
      power_steering_fluid: {
        mobile: {
          light_medium_duty: boolean,
          heavy_duty: boolean,
        },
        michelin_verified: boolean,
        in_bay: {
          light_medium_duty: boolean,
          heavy_duty: boolean,
        }
      },
      coolant: {
        mobile: {
          light_medium_duty: boolean,
          heavy_duty: boolean,
        },
        michelin_verified: boolean,
        in_bay: {
          light_medium_duty: boolean,
          heavy_duty: boolean,
        }
      },
      differential: {
        mobile: {
          light_medium_duty: boolean,
          heavy_duty: boolean,
        },
        michelin_verified: boolean,
        in_bay: {
          light_medium_duty: boolean,
          heavy_duty: boolean,
        }
      }
    }
  },
  full_mechanical: {
    electrical_diagnostics: {
      mobile: {
        light_medium_duty: boolean,
        heavy_duty: boolean,
      },
      michelin_verified: boolean,
      in_bay: {
        light_medium_duty: boolean,
        heavy_duty: boolean,
      },
    },
    engine_diagnostics: {
      basic: {
        mobile: {
          light_medium_duty: boolean,
          heavy_duty: boolean,
        },
        michelin_verified: boolean,
        in_bay: {
          light_medium_duty: boolean,
          heavy_duty: boolean,
        }
      },
      advanced: {
        mobile: {
          light_medium_duty: boolean,
          heavy_duty: boolean,
        },
        michelin_verified: boolean,
        in_bay: {
          light_medium_duty: boolean,
          heavy_duty: boolean,
        }
      },
    }
    transmission: {
      basic: {
        mobile: {
          light_medium_duty: boolean,
          heavy_duty: boolean,
        },
        michelin_verified: boolean,
        in_bay: {
          light_medium_duty: boolean,
          heavy_duty: boolean,
        }
      },
      advanced: {
        mobile: {
          light_medium_duty: boolean,
          heavy_duty: boolean,
        },
        michelin_verified: boolean,
        in_bay: {
          light_medium_duty: boolean,
          heavy_duty: boolean,
        }
      },
    }
  },
  complete_mechanical: CompleteMechanical
}

interface BasicMechanical {
  light_replacement: {
    mobile: {
      trailers_greater_than_10000_lbs: boolean,
      trailers_less_than_10000_lbs: boolean,
    },
    michelin_verified: boolean,
    in_bay: {
      trailers_greater_than_10000_lbs: boolean,
      trailers_less_than_10000_lbs: boolean,
    }
  },
  seals_and_bearing_replacement: {
    mobile: {
      trailers_greater_than_10000_lbs: boolean,
      trailers_less_than_10000_lbs: boolean,
    },
    michelin_verified: boolean,
    in_bay: {
      trailers_greater_than_10000_lbs: boolean,
      trailers_less_than_10000_lbs: boolean,
    }
  },
  basic_electrical: {
    mobile: {
      trailers_greater_than_10000_lbs: boolean,
      trailers_less_than_10000_lbs: boolean,
    },
    michelin_verified: boolean,
    in_bay: {
      trailers_greater_than_10000_lbs: boolean,
      trailers_less_than_10000_lbs: boolean,
    }
  },
  vehicle_disinfecting: {
    mobile: {
      trailers_greater_than_10000_lbs: boolean,
      trailers_less_than_10000_lbs: boolean,
    },
    michelin_verified: boolean,
    in_bay: {
      trailers_greater_than_10000_lbs: boolean,
      trailers_less_than_10000_lbs: boolean,
    }
  },
  wheel_end_replacement: {
    mobile: {
      trailers_greater_than_10000_lbs: boolean,
      trailers_less_than_10000_lbs: boolean,
    },
    michelin_verified: boolean,
    in_bay: {
      trailers_greater_than_10000_lbs: boolean,
      trailers_less_than_10000_lbs: boolean,
    }
  },
  minor_body_repair: {
    mobile: {
      trailers_greater_than_10000_lbs: boolean,
      trailers_less_than_10000_lbs: boolean,
    },
    michelin_verified: boolean,
    in_bay: {
      trailers_greater_than_10000_lbs: boolean,
      trailers_less_than_10000_lbs: boolean,
    }
  },
  trailer_inspection: {
    mobile: {
      trailers_greater_than_10000_lbs: boolean,
      trailers_less_than_10000_lbs: boolean,
    },
    michelin_verified: boolean,
    in_bay: {
      trailers_greater_than_10000_lbs: boolean,
      trailers_less_than_10000_lbs: boolean,
    }
  },
  alignment: {
    mobile: {
      trailers_greater_than_10000_lbs: boolean,
      trailers_less_than_10000_lbs: boolean,
    },
    michelin_verified: boolean,
    in_bay: {
      trailers_greater_than_10000_lbs: boolean,
      trailers_less_than_10000_lbs: boolean,
    }
  },
  basic_brake_service: {
    mobile: {
      trailers_greater_than_10000_lbs: boolean,
      trailers_less_than_10000_lbs: boolean,
    },
    michelin_verified: boolean,
    in_bay: {
      trailers_greater_than_10000_lbs: boolean,
      trailers_less_than_10000_lbs: boolean,
    }
  },
  dot_annual_inspection: {
    mobile: {
      trailers_greater_than_10000_lbs: boolean,
      trailers_less_than_10000_lbs: boolean,
    },
    michelin_verified: boolean,
    in_bay: {
      trailers_greater_than_10000_lbs: boolean,
      trailers_less_than_10000_lbs: boolean,
    }
  },
  vehicle_washes: {
    mobile: {
      trailers_greater_than_10000_lbs: boolean,
      trailers_less_than_10000_lbs: boolean,
    },
    michelin_verified: boolean,
    in_bay: {
      trailers_greater_than_10000_lbs: boolean,
      trailers_less_than_10000_lbs: boolean,
    }
  }
}

export interface CompleteMechanical {
  authorized_service_of: {
    heavy_duty_tractor_oe_manufacturers: string[],
    heavy_duty_trailer_oe_manufacturers: string[],
    medium_duty_oe_manufacturers: string[],
  }
}

export const commercialTireServicesLabels = {
  mounted_wheel_program: 'Mounted Wheel Program',
  nail_hole_repair: 'Nail Hole Repair',
  tire_balancing: 'Tire Balancing',
  tire_inspections: 'Tire Inspections',
  tire_mounting: 'Tire Mounting (Mount & Dismount)',
  tire_repairs: 'Tire Repairs',
  tire_rotations: 'Tire Rotations',
  tpms_reset_and_replacement: 'TPMS Reset & Replacements',
  vehicle_alignment: 'Vehicle Alignment',

  'tia_certified_technicians.training_200.ats': '200 (Training) ATS',
  'tia_certified_technicians.training_200.cts': '200 (Training) CTS',
  'tia_certified_technicians.certificate_or_equivalent_300.ats': '300 (Certficate or Equivalent) ATS',

  'wheel_refurbishing.powder_coating': 'Powder Coating (Steel)',
  'wheel_refurbishing.polishing': 'Polishing (Aluminum)',
};

export const commercialMechanicalServicesLabels = {
  'ase_certified_mechanics.a1_engine_repair': 'A1 - Engine Repair',
  'ase_certified_mechanics.a2_automatic_transmission_transaxle': 'A2 - Automatic Transmission/Transaxle',
  'ase_certified_mechanics.a3_manual_drive_train_and_axles': 'A3 - Manual Drive Train & Axles',
  'ase_certified_mechanics.a4_suspension_and_steering': 'A4 - Suspension & Steering',
  'ase_certified_mechanics.a5_brakes': 'A5 - Brakes',
  'ase_certified_mechanics.a6_electrical_electronic_systems': 'A6 - Electrical/Electronic Systems',
  'ase_certified_mechanics.a7_heating_and_air_conditioning': 'A7 - Heating & Air Conditioning',
  'ase_certified_mechanics.a8_engine_performance': 'A8 - Engine Performance',
  'ase_certified_mechanics.a9_light_vehicles_diesel_engines': 'A9 - Light Vehicle Diesel Engines',
  'ase_certified_mechanics.g1_auto_maintenance_and_light_repair': 'G1 - Auto Maintenance and Light Repair',
  'ase_certified_mechanics.l3_light_duty_hybrid_electric_vehicle': 'L3 - Light Duty Hybrid / Electric Vehicle',
  'towing.less_than_10_lbs': '< 10,000 lbs',
  'towing.greater_than_26_lbs': '> 26,000 lbs',
  'towing.between_10_and_26_lbs': '10,000 to 26,000 lbs',
  'basic_mechanical.alignment': 'Alignment',
  'basic_mechanical.basic_brake_service': 'Basic Brake Service',
  'basic_mechanical.basic_electrical': 'Basic Electrical',
  'basic_mechanical.dot_annual_inspection': 'DOT Annual Inspection',
  'basic_mechanical.light_replacement': 'Light Replacement',
  'basic_mechanical.minor_body_repair': 'Minor Body Repair',
  'basic_mechanical.pmvi': 'PMVI',
  'basic_mechanical.seals_and_bearing_replacement': 'Seals & Bearing Replacement',
  'basic_mechanical.trailer_inspection': 'Trailer Inspection - Including Brakes, Lights, & Tires',
  'basic_mechanical.vehicle_disinfecting': 'Vehicle Disinfecting',
  'basic_mechanical.vehicle_washes': 'Vehicle Washes',
  'basic_mechanical.wheel_end_replacement': 'Wheel End Replacement',
  'light_mechanical.air_conditioning_repair': 'Air Conditioning Repair (PU)',
  'light_mechanical.air_filter_replacement': 'Air Filter Replacement (PU)',
  'light_mechanical.alignment': 'Alignment (PU)',
  'light_mechanical.alternator_replacement': 'Alternator Replacement (PU)',
  'light_mechanical.basic_brake_service': 'Basic Brake Service (PU)',
  'light_mechanical.basic_electrical': 'Basic Electrical (PU)',
  'light_mechanical.battery_replacement': 'Battery Replacement (PU)',
  'light_mechanical.belts_and_hoses': 'Belts & Hoses (PU)',
  'light_mechanical.cabin_filter_replacement': 'Cabin Filter Replacement (PU)',
  'light_mechanical.dot_annual_inspection': 'DOT Annual Inspection (PU)',
  'light_mechanical.electric_vehicle_charging': 'Electric Vehicle Charging (PU)',
  'light_mechanical.full_unit_inspection': 'Full Unit Inspection (Power Unit & Trailer) - Including Brakes, Lights, & Tires',
  'light_mechanical.light_replacement': 'Light Replacement (PU)',
  'light_mechanical.lightbulb_replacement': 'Lightbulb Replacement (PU)',
  'light_mechanical.pmvi': 'PMVI (PU)',
  'light_mechanical.state_inspection': 'State Inspection (PU)',
  'light_mechanical.seals_and_bearing_replacement': 'Seals & Bearing (PU) Replacement',
  'light_mechanical.suspension': 'Suspension (PU)',
  'light_mechanical.vehicle_disinfecting': 'Vehicle Disinfecting (PU)',
  'light_mechanical.vehicle_washes': 'Vehicle Washes (PU)',
  'light_mechanical.wheel_end_replacement': 'Wheel End Replacement (PU)',
  'light_mechanical.windshield_wipers': 'Windshield Wipers (PU)',
  'wet_mechanical.refills_top_offs.brake_fluids': 'Brake Fluid',
  'wet_mechanical.refills_top_offs.coolant': 'Coolant',
  'wet_mechanical.refills_top_offs.diesel_emission_fluid': 'Diesel Emissions Fluid (DEF)',
  'wet_mechanical.refills_top_offs.fuel_refill_diesel': 'Fuel Refill - Diesel',
  'wet_mechanical.refills_top_offs.fuel_refill_gas': 'Fuel Refill - Gas',
  'wet_mechanical.refills_top_offs.oil': 'Oil',
  'wet_mechanical.refills_top_offs.power_steering_fluid': 'Power Steering Fluid',
  'wet_mechanical.refills_top_offs.transmission_fluid': 'Transmission Fluid',
  'wet_mechanical.refills_top_offs.windshield_fluid': 'Windshield Fluid',
  'wet_mechanical.flushes.brake_fluid': 'Brake Fluid',
  'wet_mechanical.flushes.coolant': 'Coolant',
  'wet_mechanical.flushes.differential': 'Differential',
  'wet_mechanical.flushes.fuel_system_cleaning': 'Fuel System Cleaning',
  'wet_mechanical.flushes.oil': 'Oil',
  'wet_mechanical.flushes.power_steering_fluid': 'Power Steering Fluid',
  'wet_mechanical.flushes.transmission': 'Transmission',
  'wet_mechanical.other_services.brake_fluid_exchange': 'Brake Fluid Exchange',
  'wet_mechanical.other_services.coolant_exchange': 'Coolant Exchange',
  'wet_mechanical.other_services.differential_fluid_exchange': 'Differential Fluid Exchange',
  'wet_mechanical.other_services.fuel_system_repair': 'Fuel System Repair',
  'wet_mechanical.other_services.oil_change': 'Oil Change',
  'wet_mechanical.other_services.power_steering_fluid_exchange': 'Power Steering Fluid Exchange',
  'wet_mechanical.other_services.transfer_case_fluid_exchange': 'Transfer Case Fluid Exchange',
  'wet_mechanical.other_services.transmission_fluid_exchange': 'Transmission Fluid Exchange',
  'full_mechanical.electrical_diagnostics': 'Electrical Diagnostics',
  'full_mechanical.engine_diagnostics.basic': 'Engine Diagnostics - Basic',
  'full_mechanical.engine_diagnostics.advanced': 'Engine Diagnostics - Advanced',
  'full_mechanical.transmission.basic': 'Transmission - Basic',
  'full_mechanical.transmission.advanced': 'Transmission - Advanced',
};

export const commercialMechanicalServicesLabelsAlt = {
  'towing.less_than_10_lbs': '< 4,536 kg',
  'towing.between_10_and_26_lbs': '4,536 kg to 11793 kg',
  'towing.greater_than_26_lbs': '> 11793 kg',
};

export const commercialNetworkServicesLabels = {
  mcsn: 'Member of Michelin Commercial Service Network',
};
